export enum LongRunningTaskStatus {
Pending,
Started,
Running,
Finished,
Canceled,
Failed,
}
